import {
  Component,
  inject,
  input,
  OnInit,
  signal,
  WritableSignal,
} from '@angular/core';
import { Router } from '@angular/router';
import { UserApi } from '../../shared/services/api/user.api';
import { Card } from 'primeng/card';
import { SpinnerService } from '../../core/services/spinner.service';
import { Button } from 'primeng/button';
import { APP_PATHS } from '../../core/config/app-paths';
import { catchError, EMPTY, finalize, tap } from 'rxjs';

@Component({
  selector: 'app-beneficiary-verify',
  imports: [Card, Button],
  templateUrl: './beneficiary-verify.html',
  styleUrl: './beneficiary-verify.scss',
})
export class BeneficiaryVerify implements OnInit {
  readonly #router = inject(Router);
  readonly #userApi = inject(UserApi);
  readonly #spinnerService = inject(SpinnerService);
  protected success: WritableSignal<boolean> = signal(false);
  readonly hash = input.required<string>();

  ngOnInit(): void {
    this.#spinnerService.show();
    if (this.hash()) {
      this.verifyEmail();
    } else {
      this.#spinnerService.hide();
    }
  }

  protected verifyEmail(): void {
    this.#userApi
      .verifyUserHash$(this.hash()!)
      .pipe(
        tap(() => this.success.set(true)),
        catchError(() => {
          this.success.set(false);
          return EMPTY;
        }),
        finalize(() => this.#spinnerService.hide()),
      )
      .subscribe();
  }

  navigateToMainPage(): void {
    this.#router.navigate([APP_PATHS.auth, APP_PATHS.auth.loginMethod]);
  }
}
